'use client';

import "../../debounce-C70-rAd_.js";
import { n as createAdapterProvider } from "../../context-DRdo5A2P.js";
import "../../reset-CKsIu3sM.js";
import { n as useNuqsNextPagesRouterAdapter } from "../../impl.pages-DPcvoxQ5.js";

//#region src/adapters/next/pages.ts
const NuqsAdapter = createAdapterProvider(useNuqsNextPagesRouterAdapter);

//#endregion
export { NuqsAdapter };
//# sourceMappingURL=pages.js.map